import { createRoot } from 'react-dom/client'
import React from 'react'
import 'core-js'
import 'es6-promise'
import 'isomorphic-fetch'
import 'abortcontroller-polyfill'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import './resources/i18n'

const root = createRoot(document.getElementById('root'))
root.render(<App />)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
